<script setup lang="ts">
import { PhCaretLeft } from "@phosphor-icons/vue";
</script>

<template>
  <section id="deviceView" class="device-view" aria-labelledby="deviceViewTitle" hidden>
    <header class="view-header">
      <button id="deviceBackButton" class="icon-button" type="button" aria-label="返回账号设置">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="deviceViewTitle">设备管理</h2>
        <span>查看与移除登录设备</span>
      </div>
    </header>

    <div class="device-scroll">
      <dl class="account-facts device-facts">
        <div>
          <dt>当前设备</dt>
          <dd id="accountCurrentDevice">—</dd>
        </div>
        <div>
          <dt>设备额度</dt>
          <dd id="accountDeviceUsage">正在读取</dd>
        </div>
      </dl>

      <section class="account-devices" aria-labelledby="accountDevicesTitle">
        <div class="account-section-heading">
          <h3 id="accountDevicesTitle">已登录设备</h3>
          <span id="accountDeviceCount"></span>
        </div>
        <p id="accountDeviceStatus" class="account-device-status" role="status" aria-live="polite">正在读取设备</p>
        <div id="accountDeviceList" class="account-device-list"></div>
      </section>

      <p id="deviceError" class="auth-message account-error" data-tone="error" role="alert" hidden></p>
    </div>
  </section>
</template>
